import { navigate, routes } from '@redwoodjs/router'

import {
  SegmentedTabs,
  type SegmentedTabItem,
} from 'src/components/Core/SegmentedTabs'
import { buildRouteWithPreservedSearch } from 'src/lib/url-search-params.utils'

export type ActivityAnalyticsSection = 'calls' | 'sms' | 'email'

const SECTION_TABS: ReadonlyArray<SegmentedTabItem<ActivityAnalyticsSection>> =
  [
    { value: 'calls', label: 'Calls' },
    { value: 'sms', label: 'SMS' },
    { value: 'email', label: 'Email' },
  ]

export interface ActivityAnalyticsSectionTabsProps {
  section: ActivityAnalyticsSection
}

export const ActivityAnalyticsSectionTabs = ({
  section,
}: ActivityAnalyticsSectionTabsProps) => {
  const handleChange = (value: ActivityAnalyticsSection) => {
    if (value === section) return
    const routeMap = {
      calls: routes.activityAnalyticsCalls(),
      sms: routes.activityAnalyticsSms(),
      email: routes.activityAnalyticsEmail(),
    }
    // Carry dateRange and other shared filters across Calls / SMS / Email.
    // Drop `tab` — it is call-analytics-specific and not meaningful on SMS/Email.
    navigate(buildRouteWithPreservedSearch(routeMap[value], ['tab']))
  }

  return (
    <SegmentedTabs
      tabs={SECTION_TABS}
      value={section}
      onChange={handleChange}
      ariaLabel="Activity analytics type"
    />
  )
}

export default ActivityAnalyticsSectionTabs
